export default __webpack_public_path__ + "static/media/Skeleton-3D-Model-00.d1c3f349.jpg";